import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import DrugIndicationList from "../drugs/DrugIndicationList";
import FavouriteButton from "../../components/FavouriteButton/FavouriteButton";
import useToast from "../../hooks/useToast";
import style from "./DrugOverviewAppPage.module.scss";
import {
  DRUG_INDEX_FAVOURITES_STORAGE_KEY,
  DRUG_INDEX_FAVOURITE_TYPE,
} from "../../components/FavouriteButton/favouritesService";

const DEFAULT_FAVOURITE_TOAST_DURATION = 3000;

const DrugOverviewAppPage = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const [searchParams] = useSearchParams();
  const toast = useToast();
  const drugName = searchParams.get("drug");

  const triggerToast = (added) => {
    toast.triggerToast({
      type: "info",
      primaryMessage: added ? "Added to favourites" : "Removed from favourites",
      rightText: '<a href="/app/favourites?tab=drug-index">View</a>',
      autoHideDuration: DEFAULT_FAVOURITE_TOAST_DURATION,
    });
  };

  return (
    <div>
      <div className={style.topBar}>
        <button
          type="button"
          className={style.backButton}
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <i className="tg-icons-LeftArrow iconSize size-16"></i>
        </button>
        {drugName && (
          <FavouriteButton
            sectionTitle={drugName}
            sectionUrl={`${pathname}${search}`}
            type={DRUG_INDEX_FAVOURITE_TYPE}
            triggerToast={triggerToast}
            styling={style.favouriteButton}
            storageKey={DRUG_INDEX_FAVOURITES_STORAGE_KEY}
          />
        )}
      </div>
      <DrugIndicationList />
    </div>
  );
};

export default DrugOverviewAppPage;
